import {
  match,
  model as tftMatchModel,
  Set as tftSetModel,
} from "@/data-models/tft-match-data.mjs";
import {
  gqlModel as tftPlayerGqlModel,
  League as tftRankModel,
  model as tftPlayerModel,
} from "@/data-models/tft-player.mjs";
import { PlayerMatchStats } from "@/data-models/tft-player-stats.mjs";
import gql from "@/util/graphql-query.mjs";

export const PlayersById = gql`
  query profilesById(
    $ids: [String]
  ) {
    profilesById(ids: $ids) { ${tftPlayerModel} }
  }
`;

export const Profile = gql`
  query profile(
    $gameName: String,
    $tagLine: String,
    $patchId: ID,
    $queueId: ID,
    $region: Region!,
  ) {
    profile(gameName: $gameName, region: $region, tagLine: $tagLine) { 
      ${tftPlayerModel}
      ranks(patchId: $patchId, queueId: $queueId) {${tftRankModel}} 
    }
  }
`;

export const Set = gql`
  query set(
    $number: Int!
  ) {
    set(
      number: $number
    ) {
      ${tftSetModel}
    }
  }
`;

export const PlayerStats = gql`
  query GetPlayerMatchStats(
    $first: Int
    $patchId: ID
    $region: Region
    $setId: ID
    $tftProfileId: Int!
  ) {
    playerMatchStats(
      first: $first
      patchId: $patchId
      region: $region
      setId: $setId
      tftProfileId: $tftProfileId
    ) {
      ${PlayerMatchStats}
    }
  }
`;

export const LeagueProfile = gql`
  query LeagueProfile($region: Region!, $summoner_name: String!) {
    leagueProfile(region: $region, summoner_name: $summoner_name) {
      id
    }
  }
`;

const matchWithRank = gql`
  ${tftMatchModel}  
  tftProfile ${tftPlayerGqlModel} 
`;

export const Matchlist = gql`
  query playerMatches($first: Int, $region: Region!, $tftProfileId: Int!, $patchId: ID, $queueId: ID) {
    playerMatches(first: $first, region: $region, tftProfileId: $tftProfileId) { 
      ${matchWithRank}
    }
  }
`;

export const Match = gql`
  query match($matchId: String!, $patchId: ID, $region: Region!, $setId: ID, $queueId: ID) {
    match(matchId: $matchId, patchId: $patchId, region: $region, setId: $setId) { 
      ${match}
      playerMatches {${matchWithRank}}
    }
  }
`;

export const proBuildMatches = gql`
  query probuildMatches($first: Int, $maximumPlacement: Int, $region: Region, $patchId: ID, $queueId: ID) {
    probuildMatches(first: $first, maximumPlacement: $maximumPlacement, region: $region) { 
      ${matchWithRank}
    }
  }
`;

export const UpdateTFTRankMutation = gql`
mutation updateTFTRankMutation($input: updateLeagueInput!) {
  updateLeague(input: $input) {
    s {
     ${tftPlayerModel}
    }
  }
}
`;

export const UpdateMatchDataMutation = gql`
  mutation createM($input: createMInput!) {
    createM(input: $input) {
      m {
        createdAt
        data
        length
        matchid
        players
        queueId
      }
    }
  }
`;

export const ExecuteDatabricksQuery = gql`
  query ExecuteDatabricksQuery(
    $game: SupportedGame!
    $queryName: String!
    $params: [DatabricksQueryParameterInput!]
  ) {
    executeDatabricksQuery(
      game: $game
      queryName: $queryName
      params: $params
    ) {
      payload
    }
  }
`;

export const UploadPartialMatch = gql`
  mutation uploadPartialMatch(
    $gameLength: Int!
    $gameStartTime: Int!
    $matchId: String!
    $patchMajorVersion: Int!
    $patchMinorVersion: Int!
    $players: Map!
    $queueId: ID!
    $region: Region!
  ) {
    uploadPartialMatch(
      gameLength: $gameLength
      gameStartTime: $gameStartTime
      matchId: $matchId
      patchMajorVersion: $patchMajorVersion
      patchMinorVersion: $patchMinorVersion
      players: $players
      queueId: $queueId
      region: $region
    )
  }
`;

export const UploadPartialMatchRound = gql`
  mutation uploadPartialMatchRound(
    $matchId: String!
    $region: Region!
    $round: Map!
  ) {
    uploadPartialMatchRound(matchId: $matchId, region: $region, round: $round)
  }
`;
